import { handleActions } from 'redux-actions-helpers'
import { InitialState } from './types'
import * as actions from './actions'

const initialState: InitialState = {
  contest: null,
  myWorks: null,
  works: null,
  isFetchingContests: false,
  isFetchingMyWorks: false,
  isFetchingWorks: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchContest]: state => {
      return {
        ...state,
        isFetchingContests: true,
        error: initialState.error,
      }
    },
    [actions.fetchContestSuccess]: (state, action) => {
      return {
        ...state,
        contest: action.result,
        isFetchingContests: false,
      }
    },
    [actions.fetchContestFailure]: (state, action) => {
      return {
        ...state,
        isFetchingContests: false,
        error: action.error,
      }
    },
    [actions.fetchMyWorks]: state => {
      return {
        ...state,
        isFetchingMyWorks: true,
        error: initialState.error,
      }
    },
    [actions.fetchMyWorksSuccess]: (state, action) => {
      return {
        ...state,
        myWorks: action.result,
        isFetchingMyWorks: false,
      }
    },
    [actions.fetchMyWorksFailure]: (state, action) => {
      return {
        ...state,
        isFetchingMyWorks: false,
        error: action.error,
      }
    },
    [actions.fetchWorks]: state => {
      return {
        ...state,
        isFetchingWorks: true,
        error: initialState.error,
      }
    },
    [actions.fetchWorksSuccess]: (state, action) => {
      return {
        ...state,
        works: action.result,
        isFetchingWorks: false,
      }
    },
    [actions.fetchWorksFailure]: (state, action) => {
      return {
        ...state,
        isFetchingWorks: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
